import React, { useState, useEffect } from 'react';
import {useDispatch, useSelector} from 'react-redux'
import GetCards from "../../components/GetCards/GetCards";
import { H3 } from "../../styles/typography/typography.js";
import Button from "../../components/Button/Button";
import {
    ContainerStyled,
    WrapperStyled,
    ImageWrapperStyled,
} from "./style";
import i18n from "i18next";
import {getPageContent} from '../../store/channel/actions'
import { withTranslation } from "react-i18next";
import { Container } from "../../components/Container/Container";
import Filter from "../../components/Filter/Filter";

import { ContainerCatalogStyled } from "../../components/Container/style";

const Home = ({ isMobile }) => {
    // скрываем основной контент страницы и показываем результаты фильтрации
    const [hiddenContentPage, setHiddenContentPage] = useState(false);
    const channel = useSelector((state) => state.channelContent)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getPageContent('main')) // диспатчим каналы, продукты, о нас
    }, [dispatch])

    const pageContent = channel.pageContent // о нас
    const loadButtonText = channel.loadButtonText

    const _hiddenContentPage = (x) => {
        setHiddenContentPage(x);
    }

    return (
        <>
            <div className="toast toast-primary">
                {/* Current window width: {windowWidth} */}
            </div>
            <GetCards sourceCards="slides" contentType={(i18n.language === 'en') ? 'project' : 'проект'} cardDisplayType="topbanner" isMobile={isMobile} />
            <ContainerCatalogStyled>
                <Filter _hiddenContentPage={_hiddenContentPage} />
                <div style={!hiddenContentPage ? { height: "auto", overflow: "" } : { height: "0", overflow: "hidden" }}>
                    <Container>
                        <GetCards sourceCards="collections" link="/collections" type="collections" title={i18n.t(`home.collections`)} cardDisplayType="carousel" />
                        <GetCards sourceCards="events" link="/events" type="events" title={i18n.t(`home.events`)} cardDisplayType="carousel" />
                    </Container>
                    <ContainerStyled>
                        <ImageWrapperStyled>
                            {(i18n.language === 'en') ? <img src="images/banner_gpm_en.png" alt="" />
                                : <img src="images/banner_gpm.jpg" alt="" />}
                        </ImageWrapperStyled>
                        <WrapperStyled>
                            <H3>
                                {pageContent.data?.content.main?.mainText}
                            </H3>
                            {(i18n.language === 'en') ?
                                <a href="documents/catalogue_eng.pdf" download >
                                    <Button as="a" href="/" label={loadButtonText} size="big" primary />
                                </a>
                                :
                                <a href="documents/catalogue_rus.pdf" download >
                                    <Button as="a" href="/" label={loadButtonText} size="big" primary />
                                </a>
                            }
                        </WrapperStyled>
                    </ContainerStyled>
                </div>
            </ContainerCatalogStyled>
        </>
    );
};

export default withTranslation()(Home);
